@import "../../global/visualization-base.scss";

:host {
  --uui-circular-chart-gap: var(--uui-large-spacing);
  --uui-circular-chart-legend-row-gap: var(--uui-small-gap);
  --uui-circular-chart-legend-tile-bottom-margin: var(--uui-x-small-padding);
  --uui-circular-chart-legend-title-font-weight: var(--uui-font-weight-bold);
  --uui-circular-chart-legend-label-right-padding: var(--uui-large-padding);
  --uui-circular-chart-legend-numeral-left-padding: var(--uui-small-padding);

  @include chart-host;
}

.circular-chart {
  &-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    gap: var(--uui-circular-chart-gap);

    &-column {
      flex-direction: column;
    }

    &-hidden {
      display: none;
    }
  }

  &-legend {
    &-wrapper {
      &-grow {
        flex-grow: 1;
        width: 100%;
      }
    }

    &-grid {
      display: grid;
      align-items: center;
      row-gap: var(--uui-circular-chart-legend-row-gap);
    }

    &-title {
      display: flex;
      margin-bottom: var(--uui-circular-chart-legend-tile-bottom-margin);
      align-items: center;

      > span {
        font-weight: var(--uui-circular-chart-legend-title-font-weight);
      }
    }

    &-dot {
      @include legend-dot;
    }

    &-link {
      @include legend-link;
    }

    &-label {
      padding-right: var(--uui-circular-chart-legend-label-right-padding);
    }

    &-numeral {
      margin-left: auto;
      padding-left: var(--uui-circular-chart-legend-numeral-left-padding);
    }
  }

  &-tooltip {
    &-container {
      @include tooltip-container;

      // reset legend margin bottom for tooltip
      .circular-chart-legend-grid {
        > span {
          margin-bottom: 0;
        }
      }
    }

    &-width {
      max-width: 300px;
      word-wrap: break-word;
    }

    &-description {
      margin-bottom: 0;
    }
  }
}
